import { Link } from 'react-router-dom';

const BlogPostCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-slate-900 to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-full mb-6">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Secure Your Organization?
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
              Take the next step in strengthening your cybersecurity posture. Our experts are ready to help you implement the strategies discussed in this article.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-600 hover:to-emerald-600 text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-user-line mr-2"></i>
              Schedule a Consultation
            </Link>
            
            <Link
              to="/blog"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-gray-400 hover:border-white text-gray-300 hover:text-white font-semibold rounded-lg transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-article-line mr-2"></i>
              Read More Articles
            </Link>
          </div>
          
          <div className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-gray-400 text-sm">
              Join over 10,000+ organizations that trust our cybersecurity expertise
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogPostCTA;